import cs from "classnames";
import React from "react";
import { FaTimes } from "react-icons/fa";

import { Button } from "src/common/components/Button";
import { Portal } from "src/common/components/Portal";

import "./Modal.css";

interface ModalProps {
	className?: string;
	isFullSize?: boolean;
	title?: React.ReactNode;
	footer?: React.ReactNode;
	onClose(): unknown;
}

export const Modal: React.FunctionComponent<
	React.PropsWithChildren<ModalProps>
> = ({ className, isFullSize = true, title, footer, onClose, children }) => (
	<Portal>
		<div
			className={cs(
				"modal",
				{ "modal--full-size": isFullSize },
				className
			)}
		>
			<div className="modal__fade" />
			<div className="modal__content">
				<div className="modal__header">
					{title && <h2>{title}</h2>}
					<Button type="button" variant="icon" onClick={onClose}>
						<FaTimes />
					</Button>
				</div>
				<div className="modal__body">{children}</div>
				{footer && <div className="modal__footer">{footer}</div>}
			</div>
		</div>
	</Portal>
);
